"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var view_models_1 = require("./../view-models");
var validators_1 = require("./../validators");
var view_config_models_1 = require("./../view-config-models");
var constants_1 = require("../validators/constants");
var moment = require("moment");
var TravelerDetailComponent = (function () {
    function TravelerDetailComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.genders = [{
                value: '',
                display: 'Select'
            }, {
                value: 'male',
                display: 'Male'
            }, {
                value: 'female',
                display: 'Female'
            }];
        this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        this.isFocused = false;
    }
    Object.defineProperty(TravelerDetailComponent.prototype, "phonePlaceHolder", {
        get: function () {
            return (this.isFocused) ? '(999) 999-999' : 'Phone Number';
        },
        enumerable: true,
        configurable: true
    });
    TravelerDetailComponent.prototype.ngOnChanges = function (changes) {
        if ((this.form && this.traveler && this.configuration && !this.formInitialized) ||
            (this.formInitialized && changes['form'])) {
            this.setupStates();
            this.buildForm();
        }
    };
    TravelerDetailComponent.prototype.setUpValidationMessages = function () {
        this.validationMessages = {
            'firstName': {
                'required': 'First name is required.',
                'maxlength': 'First name cannot be more than 40 characters long.'
            },
            'lastName': {
                'required': 'Last name is required.',
                'maxlength': 'Last name cannot be more than 80 characters long.'
            },
            'birthDate': {
                'required': 'Date of Birth is required.',
                'afterToday': 'Date of Birth cannot be in the future.',
                'invalid': 'Date of Birth must be a valid date in mm/dd/yyyy format.',
                'range': "Date of Birth must be between " + this.minDOB + " and " + this.maxDOB + "."
            },
            'tripCost': {
                'required': 'Trip cost is required.',
                'invalid': 'Please enter a valid number.',
                'min': 'Trip Cost cannot be less than $0.',
                'max': 'Trip Cost should be less than $100,000 per traveler.'
            },
            'emailGroup': {
                'required': 'Email address is required.',
                'invalid': 'Please enter a valid email address.',
                'maxlength': 'Email address cannot be more than 80 characters long.'
            },
            'phoneNumber': {
                'required': 'Phone number is required.',
                'invalid': 'Please enter a valid phone number.'
            },
            'stateOrProvince': {
                'required': 'Residence is required.'
            },
            'relationshipToPolicyholder': {
                'required': 'Relationship is required.'
            },
            'gender': {
                'required': 'Gender is required.'
            },
            'age': {
                'required': 'Age is required.'
            }
        };
    };
    TravelerDetailComponent.prototype.updateInputStatus = function (status) {
        this.isFocused = status || false;
    };
    TravelerDetailComponent.prototype.setupStates = function () {
        var _this = this;
        // if no state availablity list was passed in, make all states available
        if (!this.stateAvailability || this.stateAvailability.length === 0) {
            this.stateAvailability = [];
            if (this.states) {
                this.states.forEach(function (s) {
                    var availability = new view_config_models_1.StateSellingAbility(s.isoCode2, s.name, true);
                    _this.stateAvailability.push(availability);
                });
            }
        }
    };
    TravelerDetailComponent.prototype.buildForm = function () {
        this.buildCorrelationIdControl();
        this.buildFirstNameControl();
        this.buildLastNameControl();
        this.buildBirthDateControl();
        this.buildAgeControl();
        this.buildEmailControl();
        this.buildPhoneNumberControl();
        this.buildStateOrProvinceControl();
        this.buildTripCostControl();
        this.buildGenderControl();
        this.buildRelationshipToPolicyholderControl();
        this.setUpValidationMessages();
        this.formInitialized = true;
    };
    TravelerDetailComponent.prototype.buildCorrelationIdControl = function () {
        if (!this.traveler.correlationId) {
            this.traveler.correlationId = view_models_1.TravelerDetailViewModel.generateCorrelationId();
        }
        var correlationIdControl = this.formBuilder.control(this.traveler.correlationId);
        correlationIdControl.disable();
        this.form.addControl('correlationId', correlationIdControl);
    };
    TravelerDetailComponent.prototype.buildFirstNameControl = function () {
        if (this.configuration.firstName.show) {
            var firstName = 'firstName';
            var firstNameValidators = [];
            if (this.configuration.firstName.required) {
                firstNameValidators.push(forms_1.Validators.required);
            }
            firstNameValidators.push(forms_1.Validators.maxLength(40));
            this.form.addControl(firstName, this.formBuilder.control(this.traveler.firstName, forms_1.Validators.compose(firstNameValidators)));
            if (!this.configuration.firstName.editable) {
                this.form.controls[firstName].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.buildLastNameControl = function () {
        if (this.configuration.lastName.show) {
            var lastName = 'lastName';
            var lastNameValidators = [];
            if (this.configuration.lastName.required) {
                lastNameValidators.push(forms_1.Validators.required);
            }
            lastNameValidators.push(forms_1.Validators.maxLength(80));
            this.form.addControl(lastName, this.formBuilder.control(this.traveler.lastName, forms_1.Validators.compose(lastNameValidators)));
            if (!this.configuration.lastName.editable) {
                this.form.controls[lastName].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.buildBirthDateControl = function () {
        var _this = this;
        if (this.configuration.birthDate.show) {
            var birthDate = 'birthDate';
            var birthDateValidators = [];
            if (this.configuration.birthDate.required) {
                birthDateValidators.push(forms_1.Validators.required);
                if ((this.configuration.minAge || this.configuration.maxAge) && this.configuration.birthDate.editable) {
                    var _a = this.SetupMinMaxDOBValidation(), minValue = _a.minValue, maxValue = _a.maxValue;
                    birthDateValidators.push(validators_1.dateOfBirthRangeValidator(minValue, maxValue));
                }
            }
            birthDateValidators.push(validators_1.dateOfBirthValidator());
            this.form.addControl(birthDate, this.formBuilder.control(this.traveler.birthDate, forms_1.Validators.compose(birthDateValidators)));
            if (this.configuration.age.show) {
                this.form.get(birthDate).valueChanges.subscribe(function (value) {
                    var age = _this.form.get('age');
                    if (age) {
                        age.setValue(_this.calculateAgeFromDob(value));
                    }
                });
            }
            if (!this.configuration.birthDate.editable) {
                this.form.controls[birthDate].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.buildAgeControl = function (overrideRules) {
        if (overrideRules === void 0) { overrideRules = false; }
        if (this.configuration.age.show || overrideRules) {
            var age = 'age';
            var ageValidators = [];
            if (this.configuration.age.required) {
                ageValidators.push(forms_1.Validators.required);
            }
            this.form.addControl(age, this.formBuilder.control(this.calculateAgeFromDob(this.traveler.birthDate), forms_1.Validators.compose(ageValidators)));
            if (!this.configuration.age.editable) {
                this.form.controls[age].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.buildEmailControl = function () {
        if (this.configuration.email.show) {
            var emailGroup = 'emailGroup';
            if (!this.traveler.emailGroup) {
                this.traveler.emailGroup = new view_models_1.EmailViewModel();
            }
            var emailGroupControl_1 = this.formBuilder.group({
                email: [this.traveler.emailGroup.email, []],
                noEmail: [this.traveler.emailGroup.noEmail, []],
            }, {
                validator: validators_1.emailValidator(this.configuration.email.required, 80)
            });
            if (this.configuration.email.required) {
                // when one control receives input, clear input on other control
                emailGroupControl_1.controls['email'].valueChanges.subscribe(function (data) {
                    if (data && data.length > 0 && emailGroupControl_1.controls['noEmail'].value === true) {
                        emailGroupControl_1.controls['noEmail'].setValue(false);
                    }
                });
                emailGroupControl_1.controls['noEmail'].valueChanges.subscribe(function (data) {
                    if (data === true) {
                        emailGroupControl_1.controls['email'].setValue('');
                        emailGroupControl_1.controls['email'].updateValueAndValidity();
                    }
                });
            }
            else {
                emailGroupControl_1.removeControl('noEmail');
            }
            this.form.addControl(emailGroup, emailGroupControl_1);
            if (!this.configuration.email.editable) {
                this.form.controls[emailGroup].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.buildPhoneNumberControl = function () {
        if (this.configuration.phoneNumber.show) {
            var phoneNumber = 'phoneNumber';
            var phoneValidators = [];
            if (this.configuration.phoneNumber.required) {
                phoneValidators.push(forms_1.Validators.required);
            }
            phoneValidators.push(validators_1.phoneNumberValidator());
            this.form.addControl(phoneNumber, this.formBuilder.control(this.traveler.phoneNumber, forms_1.Validators.compose(phoneValidators)));
            if (!this.configuration.phoneNumber.editable) {
                this.form.controls[phoneNumber].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.buildStateOrProvinceControl = function () {
        if (this.configuration.residence.show) {
            // Must be setup as a form group to adhere to traveler contract (traveler.address.stateOrProvince)
            var stateOrProvinceGroup = 'address';
            var stateOrProvinceGroupControl = this.formBuilder.group({
                stateOrProvince: [this.traveler.address ? this.traveler.address.stateOrProvince : '', this.configuration.residence.required ? [forms_1.Validators.required] : []]
            });
            this.form.addControl(stateOrProvinceGroup, stateOrProvinceGroupControl);
            if (!this.configuration.residence.editable) {
                this.form.controls[stateOrProvinceGroup].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.buildTripCostControl = function () {
        if (this.configuration.tripCost.show) {
            var tripCost = 'tripCost';
            var tripCostValidators = [];
            if (this.configuration.tripCost.required) {
                tripCostValidators.push(forms_1.Validators.required);
            }
            tripCostValidators.push(validators_1.tripCostValidator(0, 100000));
            this.form.addControl(tripCost, this.formBuilder.control(this.traveler.tripCost, forms_1.Validators.compose(tripCostValidators)));
            if (!this.configuration.tripCost.editable) {
                this.form.controls[tripCost].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.buildGenderControl = function () {
        if (this.configuration.gender.show) {
            var gender = 'gender';
            var genderValidators = [];
            if (this.configuration.gender.required) {
                genderValidators.push(forms_1.Validators.required);
            }
            this.form.addControl(gender, this.formBuilder.control(this.traveler.gender || '', forms_1.Validators.compose(genderValidators)));
            if (!this.configuration.gender.editable) {
                this.form.controls[gender].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.buildRelationshipToPolicyholderControl = function () {
        if (this.configuration.relationshipToPolicyholder.show) {
            var relationshipToPolicyholder = 'relationshipToPolicyholder';
            var relationshipToPolicyholderValidators = [];
            if (this.configuration.relationshipToPolicyholder.required) {
                relationshipToPolicyholderValidators.push(forms_1.Validators.required);
            }
            this.form.addControl(relationshipToPolicyholder, this.formBuilder.control(this.traveler.relationshipToPolicyholder || '', forms_1.Validators.compose(relationshipToPolicyholderValidators)));
            if (!this.configuration.relationshipToPolicyholder.editable) {
                this.form.controls[relationshipToPolicyholder].disable();
            }
        }
    };
    TravelerDetailComponent.prototype.calculateAgeFromDob = function (dateOfBirth) {
        if (dateOfBirth) {
            return moment().diff(new Date(dateOfBirth), 'year');
        }
        else {
            return undefined;
        }
    };
    TravelerDetailComponent.prototype.SetupMinMaxDOBValidation = function () {
        var today = this.purchaseDate ? moment(this.purchaseDate, constants_1.Constants.DATE_PARSE_FORMAT) : moment();
        var minValue = moment(today).subtract(this.configuration.maxAge || constants_1.Constants.MAXIMUM_AGE, 'year');
        var maxValue = moment(today).subtract(this.configuration.minAge || constants_1.Constants.MINIMUM_AGE, 'year');
        this.minDOB = moment(minValue).format(constants_1.Constants.DATE_DISPLAY_FORMAT);
        this.maxDOB = moment(maxValue).format(constants_1.Constants.DATE_DISPLAY_FORMAT);
        return { minValue: minValue, maxValue: maxValue };
    };
    return TravelerDetailComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], TravelerDetailComponent.prototype, "form", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", view_models_1.TravelerDetailViewModel)
], TravelerDetailComponent.prototype, "traveler", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TravelerDetailComponent.prototype, "states", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TravelerDetailComponent.prototype, "stateAvailability", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], TravelerDetailComponent.prototype, "relationships", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", view_config_models_1.TravelerDetailViewConfig)
], TravelerDetailComponent.prototype, "configuration", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TravelerDetailComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TravelerDetailComponent.prototype, "purchaseDate", void 0);
TravelerDetailComponent = __decorate([
    core_1.Component({
        selector: 'traveler-detail',
        template: "<form *ngIf=\"configuration && formInitialized\" [formGroup]=\"form\" novalidate>     <input type=\"hidden\" formControlName=\"correlationId\" />     <div class=\"row\">         <div *ngIf=\"configuration.firstName.show\" class=\"col-md-3 form-group\">             <label for=\"firstName\">First Name</label>             <input type=\"text\" class=\"form-control traveler-detail-firstName\" formControlName=\"firstName\" placeholder=\"First Name\">             <validation-messages [control]=\"form.controls.firstName\"                                  [messages]=\"validationMessages.firstName\"                                  [submitted]=\"submitted\"></validation-messages>         </div>         <div *ngIf=\"configuration.lastName.show\" class=\"col-md-3 form-group\">             <label for=\"lastName\">Last Name</label>             <input type=\"text\" class=\"form-control traveler-detail-lastName\" formControlName=\"lastName\" placeholder=\"Last Name\">             <validation-messages [control]=\"form.controls.lastName\"                                  [messages]=\"validationMessages.lastName\"                                  [submitted]=\"submitted\"></validation-messages>         </div>         <div *ngIf=\"configuration.birthDate.show\" class=\"col-md-3 form-group\">             <label for=\"birthDate\">Date Of Birth</label>             <masked-datepicker formControlName=\"birthDate\" placeholder=\"Date of Birth\"></masked-datepicker>             <validation-messages [control]=\"form.controls.birthDate\"                                  [messages]=\"validationMessages.birthDate\"                                  [submitted]=\"submitted\"></validation-messages>         </div>         <div *ngIf=\"configuration.tripCost.show\" class=\"col-md-3 form-group\">             <label for=\"tripCost\">Trip Cost</label>             <div class=\"input-group\">                 <div class=\"input-group-addon\">$</div>                 <input number-only type=\"number\" class=\"form-control traveler-detail-tripCost\" formControlName=\"tripCost\" placeholder=\"Trip Cost\">             </div>             <validation-messages [control]=\"form.controls.tripCost\"                                  [messages]=\"validationMessages.tripCost\"                                  [submitted]=\"submitted\"></validation-messages>         </div>     </div>     <div class=\"row\">         <div *ngIf=\"configuration.email.show\" class=\"col-md-3 form-group\" formGroupName=\"emailGroup\">             <label for=\"emailAddress\">Email Address</label>             <span>                 <a tooltip=\"This should be the customer's email address. Policy documents are assigned based upon this information.\">                     <span class=\"fa fa-question-circle\"></span>                     <span class=\"hidden-xs\"></span>                 </a>             </span>             <input type=\"text\" class=\"form-control traveler-detail-email\" formControlName=\"email\" placeholder=\"Email Address\">             <div *ngIf=\"configuration.email.required\">                 <label>                     <input type=\"checkbox\" formControlName=\"noEmail\" />                     <span>No Email Address</span>                 </label>             </div>             <validation-messages [control]=\"form.controls.emailGroup\"                                  [messages]=\"validationMessages.emailGroup\"                                  [submitted]=\"submitted\"></validation-messages>         </div>         <div *ngIf=\"configuration.phoneNumber.show\" class=\"col-md-3 form-group\">             <label for=\"phoneNumber\">Phone Number</label>             <input type=\"text\" class=\"form-control traveler-detail-phoneNumber\" formControlName=\"phoneNumber\" [placeholder]=\"phonePlaceHolder\" [textMask]=\"{mask: phoneMask}\" (blur)=\"updateInputStatus(false)\" (click)=\"updateInputStatus(true)\">             <validation-messages [control]=\"form.controls.phoneNumber\"                                  [messages]=\"validationMessages.phoneNumber\"                                  [submitted]=\"submitted\"></validation-messages>         </div>         <div *ngIf=\"configuration.residence.show\" class=\"col-md-3 form-group\" formGroupName=\"address\">             <label for=\"stateOrProvince\">Residence</label>             <select class=\"form-control traveler-detail-residence\" formControlName=\"stateOrProvince\">                 <option value=\"\">Select</option>                 <option *ngFor=\"let state of stateAvailability\" value=\"{{state.isoCode2}}\" [class.notAvailable]=\"!state.canSell\">{{state.name}}</option>             </select>             <validation-messages [control]=\"form.controls.address.controls.stateOrProvince\"                                  [messages]=\"validationMessages.stateOrProvince\"                                  [submitted]=\"submitted\"></validation-messages>         </div>         <div *ngIf=\"configuration.age.show\" class=\"col-md-1 form-group\">             <label for=\"age\">Age</label>             <input type=\"text\" class=\"form-control traveler-detail-age\" formControlName=\"age\">             <validation-messages [control]=\"form.controls.age\"                                  [messages]=\"validationMessages.age\"                                  [submitted]=\"submitted\"></validation-messages>         </div>         <div *ngIf=\"configuration.gender.show\" class=\"col-md-3 form-group\">             <label for=\"gender\">Gender</label>             <select type=\"text\" class=\"form-control traveler-detail-gender\" formControlName=\"gender\">                 <option *ngFor=\"let gender of genders\" value=\"{{gender.value}}\">{{gender.display}}</option>             </select>             <validation-messages [control]=\"form.controls.gender\"                                  [messages]=\"validationMessages.gender\"                                  [submitted]=\"submitted\"></validation-messages>         </div>         <div *ngIf=\"configuration.relationshipToPolicyholder.show\" class=\"col-md-4 form-group\">             <label for=\"age\">Relationship To Primary</label>             <select type=\"text\" class=\"form-control traveler-detail-relationship\" formControlName=\"relationshipToPolicyholder\">                 <option value=\"\">Select</option>                 <option *ngFor=\"let relationship of relationships\" value=\"{{relationship.key}}\" [attr.disabled]=\"(relationship.canSelect === false ? true : null)\">{{relationship.displayValue}}</option>             </select>             <validation-messages [control]=\"form.controls.relationshipToPolicyholder\"                                     [messages]=\"validationMessages.relationshipToPolicyholder\"                                     [submitted]=\"submitted\"></validation-messages>         </div>     </div> </form>",
        styles: ["\n        option.notAvailable {\n            color: #b3b3b3;\n        }\n    "],
        providers: []
    }),
    __metadata("design:paramtypes", [forms_1.FormBuilder])
], TravelerDetailComponent);
exports.TravelerDetailComponent = TravelerDetailComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/traveler-details/traveler-detail.component.js